// src/utils/sagas/withLoader.ts
import { call, put, delay } from "redux-saga/effects";
import { showLoader, hideLoader } from "../loader/slice";

export function* withLoader<T>(
  saga: () => Generator<any, T, any>,
  minDelay = 300
): Generator<any, T, any> {
  try {
    yield put(showLoader());
    const result: T = yield call(saga);
    yield delay(minDelay);
    return result;
  } catch (error) {
    throw error;
  } finally {
    yield put(hideLoader());
  }
}
